module.exports = __webpack_public_path__ + "pin_grey.9c9ad8.png";